import '~/entrypoints/config/init';

import { camelCase } from 'lodash-es';

import Vue from 'vue';
import HubApp from '~/plugins/hub_app';
import AppBanner from '~/components/AppBanner.vue';
import { extractPropsFromPromotion } from '../utils/promotion_banner_props_utils';

const BannersEventEmitter = new Vue();
let counter = 0;
const initializeBanners = (promotions = []) => {
  promotions.forEach((promotionConfig) => {
    // Create a new mounting point for each promotion to avoid removing/replacing the original one upon mounting the
    // first banner in the list.
    const mountElement = document.createElement('div');
    // We make sure that we normalize all the keys in the config to have camel case keys.
    // Then we abstract those that are needed for the root banner component to work and mount
    // the specific type of banner; then pass the rest of fields in the config to a generic
    // `bannerProps`. We use the extractPropsFromElement method to do that.
    const finalProps = extractPropsFromPromotion(promotionConfig);
    // Create a unique name for the banner for possible reference later on via the `window` object.
    //
    // TODO: This might be interesting to have it come from the backend with a specific name
    // that we can then do something like: `AppBanner::${camelCase(promotionName)}`. Make it
    // more readable and identifiable.
    const bannerName = `AppBanner::${camelCase(finalProps.promotionType)}::${counter}`;

    window.VueAppBanners[bannerName] = new Vue({
      el: mountElement,
      name: bannerName,
      render: (h) => h(AppBanner, { props: finalProps, class: 'hidden-print' }),
    });

    counter++;
  });
};

// Initialize the Vue with the base component
Vue.use(HubApp);
// Map that we can use to access the banners directly later on
window.VueAppBanners = {};
// Event emitter or event bus for cross file and boundary communication
window.BannersEventEmitter = BannersEventEmitter;

document.addEventListener('DOMContentLoaded', () => {
  /** @type {HTMLElement | null} */
  const bannerElement = document.querySelector('div[data-app-promotion-banner]');

  if (!bannerElement) {
    return;
  }

  const promotions = JSON.parse(bannerElement.dataset.appPromotionBanner || '[]');

  initializeBanners(promotions);
  // Remove the original element
  setTimeout(() => bannerElement.remove());
});

window.BannersEventEmitter.$on('promotion-banners:init', (promotions = []) => {
  initializeBanners(promotions);
});
